import { VerificationTypeEnum } from '../enums/verification-type.enum';

// Base DTO
export class AbstractVerificationDto {
  type: VerificationTypeEnum;
  constructor(type: VerificationTypeEnum) {
    this.type = type;
  }
}

// GSTIN DTO
export class GSTINVerificaitonDto extends AbstractVerificationDto {
  gstNumber: string;
  constructor(type: VerificationTypeEnum, gstNumber: string) {
    super(type);
    this.gstNumber = gstNumber;
  }
}

// PAN DTO
export class PanVerificationDto extends AbstractVerificationDto {
  panNumber: string;
  constructor(type: VerificationTypeEnum, panNumber: string) {
    super(type);
    this.panNumber = panNumber;
  }
}

// Company Name DTO
export class CompanyNameVerificationDto extends AbstractVerificationDto {
  companyName: string;
  constructor(type: VerificationTypeEnum, companyName: string) {
    super(type);
    this.companyName = companyName;
  }
}

// CIN DTO
export class CinVerificationDto extends AbstractVerificationDto {
  cin: { companyCin: string };
  constructor(type: VerificationTypeEnum, companyCin: string) {
    super(type);
    this.cin = { companyCin };
  }
}

// MSME DTO
export class MsmeVerificationDto extends AbstractVerificationDto {
  msme: { udyamRegistrationNumber: string };
  constructor(type: VerificationTypeEnum, udyamRegistrationNumber: string) {
    super(type);
    this.msme = { udyamRegistrationNumber };
  }
}

// FSSAI DTO
export class FssaiVerificationDto extends AbstractVerificationDto {
  fssai: { fssaiNumber: string };
  constructor(type: VerificationTypeEnum, fssaiNumber: string) {
    super(type);
    this.fssai = { fssaiNumber };
  }
}
